module.exports = __webpack_public_path__ + "e51bf1a3113c9cfd90a6662a2d50617a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/tea-pot.png
// module id = 3058
// module chunks = 0